module.exports = __webpack_public_path__ + "media/Shane Filan - Beautiful In White (Official Video) 1.14a955d5.mp3";